import { __assign } from "tslib";
import { gridSize as gridSizeFn } from '@atlaskit/theme/constants';
import { actionSectionDesktopCSS, actionSectionMobileCSS, skeletonCSS, } from '../../common/styles';
var gridSize = gridSizeFn();
var buttonHeight = gridSize * 4;
export var createButtonCSS = actionSectionDesktopCSS;
export var createButtonSkeletonCSS = function (theme) { return (__assign(__assign({ height: buttonHeight + "px", width: '68px', borderRadius: '3px', marginLeft: 12 }, createButtonCSS), skeletonCSS(theme))); };
export var createIconCSS = actionSectionMobileCSS;
export var createIconSkeletonCSS = createIconCSS;
export var getCreateButtonTheme = function (_a) {
    var create = _a.mode.create;
    return function (current, props) {
        var _a = current(props), buttonStyles = _a.buttonStyles, spinnerStyles = _a.spinnerStyles;
        return {
            buttonStyles: __assign(__assign(__assign({}, buttonStyles), create.default), { margin: 0, fontWeight: 500, ':hover': create.hover, ':focus': create.focus, 
                // :active doesn't work in FF, becasue we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                '&&': __assign({}, (props.state === 'active' && create.active)) }),
            spinnerStyles: spinnerStyles,
        };
    };
};
//# sourceMappingURL=styles.js.map